import { showError } from '@calendly/alert'
import { I18n } from '@calendly/i18n'
import { useDispatch, useStore } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { getSafeReturnTo } from 'actions/core/navigation'
import { useProductRefreshAppShell } from 'features/app_shell/product_refresh/useProductRefreshAppShell'

import { useUpdateUserMeetingIntelligenceDataMutation } from '../api'
import {
  closeLoadingModal,
  showAcknowledgementLoadingModal,
  setAcknowledgementRedirectDestination
} from '../components/wizard_modal_loader/wizard_modal_loader_slice'
import { getMeetingsUserMePath, MI_MEETINGS_TOUR } from '../constants'

const isMiEnableSuccess = (response) => response?.miEnabled === true

/**
 * Shows a loader while enabling notetaker, giving time for the async tracking job to start.
 * Redirects to the meetings page with the tour parameter when complete.
 * Uses the existing WizardAcknowledgementModal component to render the loader.
 */
export const useEnableNotetakerWithLoader = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const store = useStore()
  const [updateMiEnabled] = useUpdateUserMeetingIntelligenceDataMutation()
  const isProductRefreshAppShell = useProductRefreshAppShell()

  const enableNotetaker = async () => {
    const meetingsRedirect = `${getMeetingsUserMePath(isProductRefreshAppShell)}?${MI_MEETINGS_TOUR.STEP_ONE}=true`
    const redirectDestination = getSafeReturnTo(
      new URLSearchParams(location.search).get('returnTo')
    ) || meetingsRedirect
    dispatch(
      setAcknowledgementRedirectDestination(redirectDestination)
    )
    dispatch(showAcknowledgementLoadingModal())
    try {
      const response = await updateMiEnabled({ miEnabled: true, source: 'intro_flow' }).unwrap()
      if (!isMiEnableSuccess(response)) {
        throw new Error('Notetaker enable did not persist mi_enabled')
      }
    } catch {
      dispatch(showError(I18n.t('publisher.flash.error')))
      const state = store.getState()
      const isLoaderStillShowing = state?.meetingIntelligence?.loadingModal?.showAcknowledgementLoadingModal ?? false

      if (isLoaderStillShowing) {
        dispatch(closeLoadingModal())
      }
    }
  }

  return enableNotetaker
}
